import React from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonsContainer, Title } from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/styled';
import { IRenderSelect } from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/types';

export const RenderSelectTheme = ({ themes, onSelectTheme, highlightIndex }: IRenderSelect) =>
    <>
        <Title>Выберите тему обращения</Title>
        <ButtonsContainer data-test='popup-theme'>
            {themes.map((theme, index) =>
                <Button
                    bType={highlightIndex === index ? 'primary' : 'secondary'}
                    key={theme.code}
                    onClick={() => onSelectTheme(theme, index)}
                    data-test='popup-theme-choose'
                >
                    {theme.label}
                </Button>)}
        </ButtonsContainer>
    </>;

